// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3D0Ay","bigColWidth":"Table_bigColWidth__yy3vP","biggerColWidth":"Table_biggerColWidth__9GMNl","row":"Table_row__OXYV5","col":"Table_col__H0TEl"};